export default async ({ commit, rootGetters }) => {
    let counter = 0;

    let entry = await rootGetters['entry_video/entry']
    let main = await rootGetters['main_videos/main']
    let ending = await rootGetters['ending_video/ending']

    await entry.forEach(element => {
        counter += parseFloat(element.coef ? element.coef : 0)
    });

    await main.forEach(element => {
        counter += parseFloat(element.coef ? element.coef : 0)
    });

    await ending.forEach(element => {
        counter += parseFloat(element.coef ? element.coef : 0)
    });

    commit('setVideo', { video: counter })
}